import {CP, initParam} from "../setting/initParam";
import {
    centeredLine, createDefaultMaterial, CutPlane, InitialStruct, JoinGashAndAngleParams,
    JoinPlane,
    JoinType,
    JoinVariant,
    matBeam, ParamsGetSimpleBoard, ParamsJsonCuts, RenderElement,
    RenderStruct, simpleSize, Vec2, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {InitialStructWhithBlock} from "@3dcalc/3dpClient/dist/types/types";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";


export async function getF1(s:InitialStructWhithBlock, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {

    const joinEndAndAngleParams:JoinGashAndAngleParams = {
        gash: initParam.gash.simple,
        width: initParam.elementData.pillar.sizeBoard.h / 2,
        angle: s.a,
        indent: initParam.elementData.harness.sizeBoard.h,
        joinType: JoinType.End,
        joinPlane: JoinPlane.Bottom,
        variant: JoinVariant.GashAndAngle
    }
    const joinStartGashAndAngleParams:JoinGashAndAngleParams = {
        gash: initParam.gash.simple,
        width: initParam.elementData.pillar.sizeBoard.h / 2,
        angle: s.a,
        indent: initParam.elementData.harness.sizeBoard.h,
        joinType: JoinType.Start,
        joinPlane: JoinPlane.Bottom,
        variant: JoinVariant.GashAndAngle
    }

    const pointF3:Vec2 = [sBoard.l / 2, 0]
    const lineCut:Vec2[] = []
    lineCut.push(pointF3)
    if (s.w > 6) {
        const offsetCutF5 =
            + initParam.elementData.f2.sizeBoard.w / 2
            + initParam.elementData.f5.sizeBoard.w / 2
            + CP.maps.f4.point[0]
        lineCut.push([sBoard.l / 2 - offsetCutF5, 0])
        lineCut.push([sBoard.l / 2 + offsetCutF5, 0])
        if (s.w > 7) {
            const offsetCutF7 =
                + initParam.elementData.f2.sizeBoard.w / 2
                + initParam.elementData.f7.sizeBoard.w / 2
                + CP.maps.f6.point[0]
            lineCut.push([sBoard.l / 2 - offsetCutF7, 0])
            lineCut.push([sBoard.l / 2 + offsetCutF7, 0])
        }
    }

    const cut:ParamsJsonCuts = {
        gash: initParam.gash.simple,
        line: lineCut,
        plane: CutPlane.Bottom,
        width: initParam.elementData.f2.sizeBoard.w
    }

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: sBoard.l},
        cuts: [cut,],
        joinStart: joinStartGashAndAngleParams,
        joinEnd: joinEndAndAngleParams,
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = 'F1'
    const specID = nameGroup
    rs.group = nameGroup
    const numGroups = rs.group.length
    const meta = resultGetSimpleBoard.meta

    const line = CP.maps.f1.lineCut

    const realSeg = centeredLine(CP.maps.f1.lineCut, s.l)

    for (let i = 0; i < realSeg.length - 1; i++) {
        const x = realSeg[i][0]
        const pos:Vec3 = [x + s.block.w / 2, s.h - initParam.gash.simple + sBoard.h / 2, 0]

        const board: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: pos,
            rotation: [Math.PI / 2,0,0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID
        }
        rs.elements.push(board)
    }
    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: "Ферма - элемент №1",
        group: specID,
        count: (realSeg.length - 1),
        specId: specID
    })
    specIds.push(specID)
    rs.specIds = specIds

    return {rs: rs, spec: spec}
}
